// ClientFieldGroup — Patch 010.A.4 R6 split. Reusable for primary +
// secondary client field blocks (same fields; props point at different
// Draft slices).

import type { Draft } from './helpers'
import { formatPhone } from './helpers'

type ClientFieldKey =
  | 'client_first_name'
  | 'client_last_name'
  | 'client_email'
  | 'client_phone'
  | 'client2_first_name'
  | 'client2_last_name'
  | 'client2_email'
  | 'client2_phone'

interface Props {
  draft: Draft
  update: <K extends keyof Draft>(k: K, v: Draft[K]) => void
  prefix: 'client' | 'client2'
  primaryTestIds?: boolean
}

export function ClientFieldGroup({
  draft,
  update,
  prefix,
  primaryTestIds = false,
}: Props): JSX.Element {
  const firstKey = `${prefix}_first_name` as ClientFieldKey
  const lastKey = `${prefix}_last_name` as ClientFieldKey
  const emailKey = `${prefix}_email` as ClientFieldKey
  const phoneKey = `${prefix}_phone` as ClientFieldKey

  return (
    <>
      <div className="hcc-field-row">
        <label className="hcc-field">
          <span>First name</span>
          <input
            value={draft[firstKey] as string}
            onChange={(e) => update(firstKey, e.target.value)}
            data-testid={primaryTestIds ? 'new-project-client-first' : undefined}
          />
        </label>
        <label className="hcc-field">
          <span>Last name</span>
          <input
            value={draft[lastKey] as string}
            onChange={(e) => update(lastKey, e.target.value)}
            data-testid={primaryTestIds ? 'new-project-client-last' : undefined}
          />
        </label>
      </div>
      <div className="hcc-field-row">
        <label className="hcc-field">
          <span>Email</span>
          <input
            type="email"
            value={draft[emailKey] as string}
            onChange={(e) => update(emailKey, e.target.value)}
          />
        </label>
        <label className="hcc-field">
          <span>Phone</span>
          <input
            type="tel"
            value={draft[phoneKey] as string}
            onChange={(e) => update(phoneKey, e.target.value)}
            onBlur={(e) => update(phoneKey, formatPhone(e.target.value))}
            placeholder={prefix === 'client' ? '651-555-0100' : undefined}
          />
        </label>
      </div>
    </>
  )
}
